interface PrepareArgs {
  measure: string;
  weight: number;
  onlySymbol?: boolean;
}

const prepare = ({
  measure,
  weight,
  onlySymbol = false
}: PrepareArgs): string => {
  let measureRes = measure;
  let weightRes = weight;
  if (!onlySymbol && measure === 'кг' && weight < 1) {
    measureRes = 'г';
    weightRes *= 1000;
  }

  if (!onlySymbol && measure === 'л' && weight < 1) {
    measureRes = 'мл';
    weightRes *= 1000;
  }
  if (onlySymbol) {
    return measureRes;
  }

  return `${typeof weight === 'undefined' ? '' : weightRes} ${measureRes}`;
};

const amount = (product: any): number | string =>
  product?.catalogItem?.vesovoi === 'Y'
    ? `${product.weight_total} ${prepare({
        measure: product.catalogItem.measureItem.symbol
          ? product.catalogItem.measureItem.symbol
          : '',
        weight: product.weight_total,
        onlySymbol: true
      })}`
    : product.amount;

const Measures = {
  prepare,
  amount
};

export default Measures;
